<div class="thumbnail">
  <img [src]="thumbnailUrl" />
</div>
<icn-close-btn *ngIf="canRemove" (remove)="onRemove()"></icn-close-btn>
